import './App.css';

function SearchIcon() {
  return (
    <svg
      aria-hidden="true"
      className="search-icon"
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle cx="11" cy="11" r="6.75" stroke="currentColor" strokeWidth="1.7" />
      <path d="m16 16 4 4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  );
}

function App() {
  return (
    <div className="home">
      <main className="hero">
        <h1 className="brand" aria-label="Oraen">
          <span className="brand-primary">Ora</span>
          <span className="brand-accent">e</span>
          <span className="brand-primary">n</span>
        </h1>

        <div className="search">
          <SearchIcon />
          <input
            className="search-input"
            type="search"
            aria-label="搜索"
            placeholder="探索你感兴趣的内容"
          />
        </div>
      </main>

      <footer className="footer">
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noreferrer"
        >
          粤ICP备19133064号
        </a>
      </footer>
    </div>
  );
}

export default App;
